"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
Object.defineProperty(exports, "__esModule", { value: true });
exports.allLogos = exports.GProduct = exports.GLogoVariant = void 0;
var logos_1 = __importDefault(require("./logos"));
var GLogoVariant;
(function (GLogoVariant) {
    /** Logo without text */
    GLogoVariant["Default"] = "";
    /** Logo with brand text to the right */
    GLogoVariant["LockupHorizontal"] = "lockup-h";
    /** Logo with brand text beneath */
    GLogoVariant["LockupVertical"] = "lockup-v";
    /** Horizontal text without the logo */
    GLogoVariant["Logotype"] = "logotype";
})(GLogoVariant = exports.GLogoVariant || (exports.GLogoVariant = {}));
var GProduct;
(function (GProduct) {
    GProduct["Granular"] = "granular";
    GProduct["Agronomy"] = "granular-agronomy";
    GProduct["Business"] = "granular-business";
    GProduct["Insights"] = "granular-insights";
    GProduct["LandVisor"] = "landvisor";
    GProduct["Corteva"] = "corteva";
    GProduct["Pioneer"] = "pioneer";
    GProduct["Hoegemeyer"] = "hoegemeyer";
    GProduct["Brevant"] = "brevant";
})(GProduct = exports.GProduct || (exports.GProduct = {}));
var gColorLogos = (_a = {},
    _a[GLogoVariant.Default] = logos_1.default.GLogo,
    _a[GLogoVariant.LockupHorizontal] = logos_1.default.GLogoLH,
    _a[GLogoVariant.LockupVertical] = logos_1.default.GLogoLV,
    _a[GLogoVariant.Logotype] = logos_1.default.GLogoT,
    _a);
var gWhiteLogos = (_b = {},
    _b[GLogoVariant.Default] = logos_1.default.GLogoW,
    _b[GLogoVariant.LockupHorizontal] = logos_1.default.GLogoLHW,
    _b[GLogoVariant.LockupVertical] = logos_1.default.GLogoLVW,
    _b[GLogoVariant.Logotype] = logos_1.default.GLogoTW,
    _b);
var gDarkmodeLogos = (_c = {},
    _c[GLogoVariant.Default] = logos_1.default.GLogo,
    _c[GLogoVariant.LockupHorizontal] = logos_1.default.GLogoLHD,
    _c[GLogoVariant.LockupVertical] = logos_1.default.GLogoLVD,
    _c[GLogoVariant.Logotype] = logos_1.default.GLogoTW,
    _c);
var agronomyColorLogos = (_d = {},
    _d[GLogoVariant.Default] = logos_1.default.AgronomyLogoLH,
    _d[GLogoVariant.LockupHorizontal] = logos_1.default.AgronomyLogoLH,
    _d[GLogoVariant.LockupVertical] = logos_1.default.AgronomyLogoLV,
    _d[GLogoVariant.Logotype] = logos_1.default.AgronomyLogoT,
    _d);
var agronomyWhiteLogos = (_e = {},
    _e[GLogoVariant.Default] = logos_1.default.AgronomyLogoLHW,
    _e[GLogoVariant.LockupHorizontal] = logos_1.default.AgronomyLogoLHW,
    _e[GLogoVariant.LockupVertical] = logos_1.default.AgronomyLogoLVW,
    _e[GLogoVariant.Logotype] = logos_1.default.AgronomyLogoTW,
    _e);
var agronomyDarkmodeLogos = (_f = {},
    _f[GLogoVariant.Default] = logos_1.default.AgronomyLogoLHD,
    _f[GLogoVariant.LockupHorizontal] = logos_1.default.AgronomyLogoLHD,
    _f[GLogoVariant.LockupVertical] = logos_1.default.AgronomyLogoLVD,
    _f[GLogoVariant.Logotype] = logos_1.default.AgronomyLogoTW,
    _f);
var businessColorLogos = (_g = {},
    _g[GLogoVariant.Default] = logos_1.default.BusinessLogoLH,
    _g[GLogoVariant.LockupHorizontal] = logos_1.default.BusinessLogoLH,
    _g[GLogoVariant.LockupVertical] = logos_1.default.BusinessLogoLV,
    _g[GLogoVariant.Logotype] = logos_1.default.BusinessLogoT,
    _g);
var businessWhiteLogos = (_h = {},
    _h[GLogoVariant.Default] = logos_1.default.BusinessLogoLHW,
    _h[GLogoVariant.LockupHorizontal] = logos_1.default.BusinessLogoLHW,
    _h[GLogoVariant.LockupVertical] = logos_1.default.BusinessLogoLVW,
    _h[GLogoVariant.Logotype] = logos_1.default.BusinessLogoTW,
    _h);
var businessDarkmodeLogos = (_j = {},
    _j[GLogoVariant.Default] = logos_1.default.BusinessLogoLHD,
    _j[GLogoVariant.LockupHorizontal] = logos_1.default.BusinessLogoLHD,
    _j[GLogoVariant.LockupVertical] = logos_1.default.BusinessLogoLVD,
    _j[GLogoVariant.Logotype] = logos_1.default.BusinessLogoTW,
    _j);
var insightsColorLogos = (_k = {},
    _k[GLogoVariant.Default] = logos_1.default.InsightsLogoLH,
    _k[GLogoVariant.LockupHorizontal] = logos_1.default.InsightsLogoLH,
    _k[GLogoVariant.LockupVertical] = logos_1.default.InsightsLogoLV,
    _k[GLogoVariant.Logotype] = logos_1.default.InsightsLogoT,
    _k);
var insightsWhiteLogos = (_l = {},
    _l[GLogoVariant.Default] = logos_1.default.InsightsLogoLHW,
    _l[GLogoVariant.LockupHorizontal] = logos_1.default.InsightsLogoLHW,
    _l[GLogoVariant.LockupVertical] = logos_1.default.InsightsLogoLVW,
    _l[GLogoVariant.Logotype] = logos_1.default.InsightsLogoTW,
    _l);
var insightsDarkmodeLogos = (_m = {},
    _m[GLogoVariant.Default] = logos_1.default.InsightsLogoLHD,
    _m[GLogoVariant.LockupHorizontal] = logos_1.default.InsightsLogoLHD,
    _m[GLogoVariant.LockupVertical] = logos_1.default.InsightsLogoLVD,
    _m[GLogoVariant.Logotype] = logos_1.default.InsightsLogoTW,
    _m);
var landvisorColorLogos = (_o = {},
    _o[GLogoVariant.Default] = logos_1.default.LandVisorLogoIcon,
    _o[GLogoVariant.LockupHorizontal] = logos_1.default.LandVisorLogoLH,
    _o[GLogoVariant.LockupVertical] = logos_1.default.LandVisorLogoLV,
    _o[GLogoVariant.Logotype] = logos_1.default.LandVisorLogoT,
    _o);
var landvisorWhiteLogos = (_p = {},
    _p[GLogoVariant.Default] = logos_1.default.LandVisorLogoIconW,
    _p[GLogoVariant.LockupHorizontal] = logos_1.default.LandVisorLogoLHW,
    _p[GLogoVariant.LockupVertical] = logos_1.default.LandVisorLogoLVW,
    _p[GLogoVariant.Logotype] = logos_1.default.LandVisorLogoTW,
    _p);
var landvisorDarkmodeLogos = (_q = {},
    _q[GLogoVariant.Default] = logos_1.default.LandVisorLogoIcon,
    _q[GLogoVariant.LockupHorizontal] = logos_1.default.LandVisorLogoLHD,
    _q[GLogoVariant.LockupVertical] = logos_1.default.LandVisorLogoLVD,
    _q[GLogoVariant.Logotype] = logos_1.default.LandVisorLogoTW,
    _q);
var cortevaColorLogos = (_r = {},
    _r[GLogoVariant.Default] = logos_1.default.CortevaLogo,
    _r[GLogoVariant.LockupHorizontal] = logos_1.default.CortevaLogoLH,
    _r[GLogoVariant.LockupVertical] = logos_1.default.CortevaLogoLV,
    _r[GLogoVariant.Logotype] = logos_1.default.CortevaLogoT,
    _r);
var cortevaDarkmodeLogos = (_s = {},
    _s[GLogoVariant.Default] = logos_1.default.CortevaLogo,
    _s[GLogoVariant.LockupHorizontal] = logos_1.default.CortevaLogoLHD,
    _s[GLogoVariant.LockupVertical] = logos_1.default.CortevaLogoLVD,
    _s[GLogoVariant.Logotype] = logos_1.default.CortevaLogoTW,
    _s);
var cortevaWhiteLogos = (_t = {},
    _t[GLogoVariant.Default] = logos_1.default.CortevaLogoW,
    _t[GLogoVariant.LockupHorizontal] = logos_1.default.CortevaLogoLHW,
    _t[GLogoVariant.LockupVertical] = logos_1.default.CortevaLogoLVW,
    _t[GLogoVariant.Logotype] = logos_1.default.CortevaLogoTW,
    _t);
var pioneerColorLogos = (_u = {},
    _u[GLogoVariant.Default] = logos_1.default.PioneerLogo,
    _u[GLogoVariant.LockupHorizontal] = logos_1.default.PioneerLogoLH,
    _u[GLogoVariant.LockupVertical] = logos_1.default.PioneerLogoLV,
    _u[GLogoVariant.Logotype] = logos_1.default.PioneerLogoT,
    _u);
var pioneerDarkmodeLogos = (_v = {},
    _v[GLogoVariant.Default] = logos_1.default.PioneerLogoLD,
    _v[GLogoVariant.LockupHorizontal] = logos_1.default.PioneerLogoLHD,
    _v[GLogoVariant.LockupVertical] = logos_1.default.PioneerLogoLVD,
    _v[GLogoVariant.Logotype] = logos_1.default.PioneerLogoTW,
    _v);
var pioneerWhiteLogos = (_w = {},
    _w[GLogoVariant.Default] = logos_1.default.PioneerLogoW,
    _w[GLogoVariant.LockupHorizontal] = logos_1.default.PioneerLogoLHW,
    _w[GLogoVariant.LockupVertical] = logos_1.default.PioneerLogoLVW,
    _w[GLogoVariant.Logotype] = logos_1.default.PioneerLogoTW,
    _w);
var hoegemeyerColorLogos = (_x = {},
    _x[GLogoVariant.Default] = logos_1.default.HoegemeyerLogo,
    _x[GLogoVariant.LockupHorizontal] = logos_1.default.HoegemeyerLogoLH,
    _x[GLogoVariant.LockupVertical] = logos_1.default.HoegemeyerLogoLV,
    _x[GLogoVariant.Logotype] = logos_1.default.HoegemeyerLogoT,
    _x);
var hoegemeyerDarkmodeLogos = (_y = {},
    _y[GLogoVariant.Default] = logos_1.default.HoegemeyerLogoLD,
    _y[GLogoVariant.LockupHorizontal] = logos_1.default.HoegemeyerLogoLHD,
    _y[GLogoVariant.LockupVertical] = logos_1.default.HoegemeyerLogoLVD,
    _y[GLogoVariant.Logotype] = logos_1.default.HoegemeyerLogoTW,
    _y);
var hoegemeyerWhiteLogos = (_z = {},
    _z[GLogoVariant.Default] = logos_1.default.HoegemeyerLogoW,
    _z[GLogoVariant.LockupHorizontal] = logos_1.default.HoegemeyerLogoLHW,
    _z[GLogoVariant.LockupVertical] = logos_1.default.HoegemeyerLogoLVW,
    _z[GLogoVariant.Logotype] = logos_1.default.HoegemeyerLogoTW,
    _z);
var brevantColorLogos = (_0 = {},
    _0[GLogoVariant.Default] = logos_1.default.BrevantLogo,
    _0[GLogoVariant.LockupHorizontal] = logos_1.default.BrevantLogoLH,
    _0[GLogoVariant.LockupVertical] = logos_1.default.BrevantLogoLV,
    _0[GLogoVariant.Logotype] = logos_1.default.BrevantLogo,
    _0);
var brevantDarkmodeLogos = (_1 = {},
    _1[GLogoVariant.Default] = logos_1.default.BrevantLogoLD,
    _1[GLogoVariant.LockupHorizontal] = logos_1.default.BrevantLogoLHD,
    _1[GLogoVariant.LockupVertical] = logos_1.default.BrevantLogoLVD,
    _1[GLogoVariant.Logotype] = logos_1.default.BrevantLogoLD,
    _1);
var brevantWhiteLogos = (_2 = {},
    _2[GLogoVariant.Default] = logos_1.default.BrevantLogoW,
    _2[GLogoVariant.LockupHorizontal] = logos_1.default.BrevantLogoLHW,
    _2[GLogoVariant.LockupVertical] = logos_1.default.BrevantLogoLVW,
    _2[GLogoVariant.Logotype] = logos_1.default.BrevantLogoW,
    _2);
exports.allLogos = (_3 = {},
    _3[GProduct.Granular] = {
        color: gColorLogos,
        darkMode: gDarkmodeLogos,
        white: gWhiteLogos,
    },
    _3[GProduct.Agronomy] = {
        color: agronomyColorLogos,
        darkMode: agronomyDarkmodeLogos,
        white: agronomyWhiteLogos,
    },
    _3[GProduct.Business] = {
        color: businessColorLogos,
        darkMode: businessDarkmodeLogos,
        white: businessWhiteLogos,
    },
    _3[GProduct.Insights] = {
        color: insightsColorLogos,
        darkMode: insightsDarkmodeLogos,
        white: insightsWhiteLogos,
    },
    _3[GProduct.LandVisor] = {
        color: landvisorColorLogos,
        darkMode: landvisorDarkmodeLogos,
        white: landvisorWhiteLogos,
    },
    _3[GProduct.Corteva] = {
        color: cortevaColorLogos,
        darkMode: cortevaDarkmodeLogos,
        white: cortevaWhiteLogos,
    },
    _3[GProduct.Pioneer] = {
        color: pioneerColorLogos,
        darkMode: pioneerDarkmodeLogos,
        white: pioneerWhiteLogos,
    },
    _3[GProduct.Hoegemeyer] = {
        color: hoegemeyerColorLogos,
        darkMode: hoegemeyerDarkmodeLogos,
        white: hoegemeyerWhiteLogos,
    },
    _3[GProduct.Brevant] = {
        color: brevantColorLogos,
        darkMode: brevantDarkmodeLogos,
        white: brevantWhiteLogos,
    },
    _3);
